import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class FileQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.FILE;
  content: any;
  fileName: string;
  useLibrary: boolean;
  maxSize?: number;

  constructor(options: any = {}) {
    super(options);
    this.useLibrary = options['useLibrary'] || true;
    this.maxSize = options['maxSize'] || 10;
  }
}
